import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@antimatterhq/ui/components/card';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { cn } from '@/lib/utils';

interface DataSourceCardSkeletonProps {
  variant?: 'default' | 'preset';
  'data-testid'?: string;
}

export const DataSourceCardSkeleton: React.FC<DataSourceCardSkeletonProps> = ({
  variant,
  'data-testid': dataTestId = 'datasource-card-skeleton',
}) => {
  return (
    <Card
      className="flex min-h-60 w-full flex-col px-4 py-4"
      data-testid={dataTestId}
    >
      <CardHeader className="space-y-1 p-0">
        <div className="flex flex-row justify-between p-0">
          <Skeleton className="h-6 w-32" data-testid={`${dataTestId}-title`} />
          <Skeleton
            className="h-6 w-20 rounded-md"
            data-testid={`${dataTestId}-badge`}
          />
        </div>
        <div className="space-y-1">
          <Skeleton
            className="h-4 w-full"
            data-testid={`${dataTestId}-desc-1`}
          />
          <Skeleton
            className="h-4 w-3/4"
            data-testid={`${dataTestId}-desc-2`}
          />
          <Skeleton
            className="h-4 w-1/4"
            data-testid={`${dataTestId}-desc-3`}
          />
        </div>
      </CardHeader>

      <Spacer size="base" />

      <CardContent className="flex w-full items-center p-0">
        <Skeleton
          className={cn(
            'h-16 w-40 rounded-md',
            variant === 'preset' && 'ml-auto mr-auto',
          )}
          data-testid={`${dataTestId}-icon`}
        />
      </CardContent>

      <Spacer size="base" />

      <CardFooter className="px-0 py-0">
        <div
          className="flex w-full flex-col space-y-2"
          data-testid={`${dataTestId}-metrics`}
        >
          <Skeleton className="h-4 w-[90%]" />
          <Skeleton className="h-4 w-[90%]" />
        </div>

        <div
          className="ml-auto flex items-center space-x-3"
          data-testid={`${dataTestId}-actions`}
        >
          <Skeleton className="h-12 w-24" />
          <Skeleton className="mr-3 h-8 w-8 rounded-md" />
        </div>
      </CardFooter>
    </Card>
  );
};

export default DataSourceCardSkeleton;
